import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useFooterSettings } from "@/hooks/useFooterSettings";
import { Loader2, Save } from "lucide-react";

export function FooterSettingsForm() {
  const { footerSettings, updateSettings, isUpdating } = useFooterSettings();
  
  const [companyDescription, setCompanyDescription] = useState("");
  const [copyrightText, setCopyrightText] = useState("");
  const [copyrightYear, setCopyrightYear] = useState("");

  useEffect(() => {
    if (footerSettings) {
      setCompanyDescription(footerSettings.company_description || "");
      setCopyrightText(footerSettings.copyright_text || "");
      setCopyrightYear(footerSettings.copyright_year || new Date().getFullYear().toString());
    }
  }, [footerSettings]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    updateSettings({
      company_description: companyDescription,
      copyright_text: copyrightText,
      copyright_year: copyrightYear,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="company_description">Descrição da Empresa</Label>
        <Textarea
          id="company_description"
          value={companyDescription}
          onChange={(e) => setCompanyDescription(e.target.value)}
          placeholder="Conectando os melhores talentos em dados..."
          rows={3}
          className="resize-none"
        />
        <p className="text-xs text-muted-foreground">
          Texto exibido abaixo do logo no rodapé
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="copyright_text">Texto do Copyright</Label>
          <Input
            id="copyright_text"
            value={copyrightText}
            onChange={(e) => setCopyrightText(e.target.value)}
            placeholder="Data Hire Club. Todos os direitos reservados."
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="copyright_year">Ano do Copyright</Label>
          <Input
            id="copyright_year"
            value={copyrightYear}
            onChange={(e) => setCopyrightYear(e.target.value)}
            placeholder="2025"
            maxLength={4}
          />
        </div>
      </div>

      <div className="bg-muted/50 p-4 rounded-lg">
        <p className="text-sm text-muted-foreground">
          <strong>Preview do copyright:</strong> © {copyrightYear} {copyrightText}
        </p>
      </div>

      <Button type="submit" disabled={isUpdating} className="w-full md:w-auto">
        {isUpdating ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Salvando...
          </>
        ) : (
          <>
            <Save className="mr-2 h-4 w-4" />
            Salvar Alterações
          </>
        )}
      </Button>
    </form>
  );
}
